import _ from "lodash";
import Report from "report";
import TableReportHelper from "report/helper";
import QRCode from 'qrcode';
import Inscricao from "..";


export default class ReunioesParticipanteReport extends Report {
    constructor(obj) {
        super();
        let sortReunioes = obj.reunioes
        sortReunioes = sortReunioes.sort((a, b) => { 
            //2024-09-12T17:30
            let ha = a.horario.horario
            let hb = b.horario.horario
            return ha.localeCompare(hb)
        })

        this.obj = { ...obj, reunioes: sortReunioes };
        console.log('this.obj.participante', this.obj.participante)
        this.titleOutroParticipante = "Empresa"
        // if (this.obj.participante.tipo === "ÂNCORA") {

        //     this.titleOutroParticipante = "Fornecedor"
        // } else {
        //     this.titleOutroParticipante = "Âncora"

        // }
    }
    async generate(metaAdd) {

        const imgQrCode = await QRCode.toDataURL(Inscricao.getUrlPainelInscrito(this.obj.participante?.uid), {
            width: 128,
            margin: 1,
            color: {
                dark: "#000000",
                light: "#ffffff"
            }
        });
        this.obj.imgQrCode = imgQrCode

        super.generate(metaAdd)
    }

    get title() {
        return "Agenda de Reuniões";
    }


    get fileName() {
        return this.title + " - " + this.obj.participante.empresa.nomeFantasia;
    }

    async render() {

        return [

            // dados do arquivo aqui
            await ReunioesParticipanteReport.renderAgendaParticipante(this.obj.participante, this.obj.reunioes, this.obj.imgQrCode)

        ]
    }

    // dados do arquivo aqui
    static renderAgendaParticipante(participante, reunioes, imgQrCode) {

        const h = new TableReportHelper({ participante, reunioes });

        const content = [];

        if (imgQrCode) {


            content.push(h.panel(
                [
                    h.row(

                        h.panel(
                            [
                                h.row(
                                    h.title("Empresa: "),
                                    h.textField("participante.empresa.nomeEmpresaCracha"),
                                ),
                                // h.row(
                                //     h.title("Participante:"),
                                //     h.textField("participante.empresa.funcionarios.nomeParticipante"),
                                // ),
                                // h.row(
                                //     h.title("TELEFONE: "),
                                //     h.text(a.empresa.telComercial),
                                //     h.title("CELULAR: "),
                                //     h.text(a.empresa.celular),
                                // ),
                                h.row(
                                    h.title("Telefone:"),
                                    h.textField("participante.empresa.telComercial"),
                                ),
                                h.row(
                                    h.title("E-Mail:"),
                                    h.textField("participante.empresa.email"),
                                ),
                                h.row(
                                    h.title("Representante:"),

                                    h.textField(
                                        participante.empresa.funcionarios.nomeCracha
                                            ? "participante.empresa.funcionarios.nomeCracha"
                                            : "participante.empresa.funcionarios.nomeParticipante"
                                    ),
                                ),
                            ],
                            { widths: [80, "*"], unbreakable: true }
                        ),
                        h.panel(
                            [
                                h.row(
                                    h.title("QRCode da página do inscrito: "),
                                ),
                                h.row(

                                    { image: imgQrCode },
                                ),
                            ], { widths: ["*"] }
                        ),

                    ),

                ],
                { widths: ["*", 140], unbreakable: true }
            ))
        } else {


            content.push(h.panel(
                [
                    h.row(
                        h.title("Empresa: "),
                        h.textField("participante.empresa.nomeEmpresaCracha"),
                    ),
                    // h.row(
                    //     h.title("Participante:"),
                    //     h.textField("participante.empresa.funcionarios.nomeParticipante"),
                    // ),
                    // h.row(
                    //     h.title("TELEFONE: "),
                    //     h.text(a.empresa.telComercial),
                    //     h.title("CELULAR: "),
                    //     h.text(a.empresa.celular),
                    // ),
                    h.row(
                        h.title("Telefone:"),
                        h.textField("participante.empresa.telComercial"),
                    ),
                    h.row(
                        h.title("E-Mail:"),
                        h.textField("participante.empresa.email"),
                    ),
                    h.row(
                        h.title("Representante:"),

                        h.textField(
                            participante.empresa.funcionarios.nomeCracha
                                ? "participante.empresa.funcionarios.nomeCracha"
                                : "participante.empresa.funcionarios.nomeParticipante"
                        ),
                    ),
                ],
                { widths: [80, "*"], unbreakable: true }
            ))
        }

        // console.log("content", content)

        let reuniaoContent = [];
        reuniaoContent.push(h.row(
            h.title("Data/Hora"),
            h.title("Mesa"),
            h.title(this.titleOutroParticipante),
            // h.title("Participante 2"),
        ))

        reunioes.forEach(r => {
            // console.log('r', r)
            // console.log('r.horariotxt', r.horariotxt.split('T')[0])
            // console.log(`${r.horariotxt.split(' - ')[1]} - ${r.horariotxt.split(' - ')[0]}`)
            let empresaCracha = ""
            if (participante.uid === r.inscricao1.uid) {
                //pega inscricao2
                empresaCracha = _.get(r, "inscricao2.empresa.nomeEmpresaCracha")

                // nomeCracha não é required, pode gerar undefined no documento
                let participanteCracha = _.get(r, "inscricao2.empresa.funcionarios.nomeCracha")
                if (participanteCracha) {
                    empresaCracha = empresaCracha + " - " + participanteCracha
                } else {
                    participanteCracha = _.get(r, "inscricao2.empresa.funcionarios.nomeParticipante")
                    if (participanteCracha) {
                        empresaCracha = empresaCracha + " - " + participanteCracha
                    }
                }
            } else {
                //pega inscricao1
                empresaCracha = _.get(r, "inscricao1.empresa.nomeEmpresaCracha")

                let nomeCrachaAux = _.get(r, "inscricao1.empresa.funcionarios.nomeCracha")
                if (nomeCrachaAux) {
                    empresaCracha = empresaCracha + " - " + nomeCrachaAux
                }
            }
            reuniaoContent.push(h.row(
                h.text(`${r.horariotxt.split(' - ')[1]} - ${r.horariotxt.split(' - ')[0]}`),
                h.text(r.mesa.name),
                h.text(empresaCracha),
            ))
        });



        content.push(h.panel(
            reuniaoContent,
            {
                widths: [60, "auto", "*",]
            }
        ),)


        return content;
    }

}
